import { render, staticRenderFns } from "./MessageHeader.vue?vue&type=template&id=43d086fe&"
import script from "./MessageHeader.vue?vue&type=script&lang=js&"
export * from "./MessageHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports